const searchFilterDirective = function ($timeout, $filter) {
    return {
        link: function ($scope, element) {
            function init() {
                // The dt-search-filter directive can be used as an attribute on any element to support
                // "searching" (filtering) the items displayed.

                // Find an input with type=search within the element, which is where the user types their query.
                let $searchInput = $(element).find('input[type=search]');

                $searchInput.on('keyup', function () {
                    let query = $(this).val().toUpperCase();

                    // Select all child elements with the .dt-search-filter-item class, which are the items to be
                    // shown/hidden as the user types their query.
                    let $items = $(element).find('.dt-search-filter-item');

                    // Set initial result count to items count.
                    let searchResultCount = $items.length;

                    if (!query) {
                        // Show all items.
                        $items.show();
                        $(element).find('.dt-search-filter__no-results').remove();
                        return;
                    }

                    $items.each(function () {
                        // The text that is being searched in should be contained in an element with the
                        // dt-search-filter-text class.
                        let text = $(this).find('.dt-search-filter-text').text();
                        if (text.toUpperCase().indexOf(query) !== -1) {
                            $(this).show();
                        } else {
                            $(this).hide();
                            searchResultCount--;
                        }

                        // Display a warning if there are no results.
                        if (searchResultCount === 0) {
                            // Only append the alert if there is none already.
                            if (!$(element).find('.dt-search-filter__no-results').length) {
                                $(element).append(
                                    '<div class="dt-search-filter__no-results cart-errors alert alert-info">'
                                    + $filter('lang')('NO_RESULTS')
                                    + '</div>'
                                );
                            }
                        } else {
                            $(element).find('.dt-search-filter__no-results').remove();
                        }
                    });
                });
            }

            $timeout(function () {
                init();
            }, 0);
        },
    };
};

module.exports = searchFilterDirective;
